// HOOKS
// COMPONENTS
import Modal from "./modal.component";
import Table from "../tables/customizableTable/table.customizableTable";

const DEFAULT_CLASSNAMES = {
  container: "flex flex-row gap-4 max-w-full",
  tableContainer:
    "overflow-x-auto h-full border bg-slate-100 rounded px-1 pb-8",
};

const TableModal = ({
  isShowing,
  handleClose,
  classNames = DEFAULT_CLASSNAMES,
  tableProps = {
    classNames: {},
    header: null,
    body: null,
    data: null,
    columns: null,
  },
}) => {
  return (
    <Modal isOpen={isShowing} onClose={handleClose}>
      <div className={classNames?.container || DEFAULT_CLASSNAMES.container}>
        <div
          className={
            classNames?.tableContainer || DEFAULT_CLASSNAMES.tableContainer
          }
        >
          <Table {...tableProps} />
        </div>
      </div>
    </Modal>
  );
};

export default TableModal;
